<template>
  <div class="content">
    <div v-if="loading"></div>
    <div v-else>
      <CCol ref="content" xs="12" lg="12">
        <CCard>
          <CCardHeader style=" font-size: 0.875rem; font-weight: 500; letter-spacing: 0.0892857143em; text-transform: uppercase;">
            {{ this.fname }}
          </CCardHeader>

          <CCardBody>
            <v-tabs grow color="basil">
              <v-tab @click="openLoading">Sensors Data</v-tab>
              <!-- <v-tab @click="openLoading">Weather Data</v-tab> -->
              <v-tab @click="openLoading">Farm Information</v-tab>

              <v-tab-item>
                <div style="margin-top: 50px;">
                  <div style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;">
                    <v-row align="center" justify="center">
                      <v-col cols="4" sm="4">
                        <template>
                          <v-bottom-navigation v-model="value">
                            <v-btn value="month" @click="load_data('month')">
                              <span> last Month</span>
                              <v-icon color="#b9a26c">
                                mdi-calendar-month
                              </v-icon>
                            </v-btn>
                            <v-btn value="week" @click="load_data('week')">
                              <span> last Week </span>

                              <v-icon color="#b9a26c"
                                >mdi-calendar-range
                              </v-icon>
                            </v-btn>
                            <v-btn value="day" @click="load_data('day')">
                              <span> last 2 Day </span>
                              <v-icon color="#b9a26c"> mdi-history </v-icon>
                            </v-btn>
                          </v-bottom-navigation>
                        </template>
                      </v-col>
                      <v-col cols="8" sm="4">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs}">
                            <v-text-field
                              v-model="date"
                              label="Date range:"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dates"
                            class="mt-4"
                            :max="nowDate"
                            range
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="load_data(dates), $refs.dialog.save(dates)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-card style="padding-top: 20px;  " shaped elevation="4">
                      <v-tabs grow color="basil">
                        <v-tab @click="openLoading">
                          <v-icon color="#b9a26c">mdi-water-percent</v-icon>
                          Soil moisture (%)
                        </v-tab>

                        <v-tab
                          @click="openLoading"
                        >
                          <v-icon color="#b9a26c"
                            >mdi-lightning-bolt-outline</v-icon
                          >
                          EC (mS/cm)
                        </v-tab>

                        <v-tab @click="openLoading">
                          <v-icon color="#b9a26c">mdi-thermometer-lines</v-icon>
                          Soil Temperature (°C)
                        </v-tab>


                        <v-tab-item>
                          <v-row style="margin-top: 40px;">
                            <div class="md-layout-item">
                              <v-card>

                                <template v-if="show === false">
                                  <CChartLine
                                    :datasets="defaultDatasets"
                                    :labels="watermark_1.data.labels"
                                    :options="watermark_1.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="show === false"
                                  inset
                                ></v-divider>
                                <label class="labels_chart" v-if="show === true ">Port 1</label>
                                <!-- <label class="labels_chart" v-if="show === true && this.nodeId === 'z6-19032'"></label> -->
                                <template v-if="show === true">
                                  <CChartLine
                                    :datasets="data_water1"
                                    :labels="watermark_1.data.labels"
                                    :options="watermark_1.options"
                                  >
                                  </CChartLine>
                                  
                                </template>
                                <v-divider
                                  v-if="show === true "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show === true && port >= 2">Port 2</label>
                                <template v-if="show === true && port >= 2">
                                  <CChartLine
                                    :datasets="data_water2"
                                    :labels="watermark_2.data.labels"
                                    :options="watermark_1.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="show === true && port >= 2"
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show === true && port >= 3">Port 3</label>
                                <template v-if="show === true && port >= 3">
                                  <CChartLine
                                    :datasets="data_water3"
                                    :labels="watermark_3.data.labels"
                                    :options="watermark_3.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="show === true && port >= 3"
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show === true && port >= 4">Port 4</label>
                                <template v-if="show === true && port >= 4">
                                  <CChartLine
                                    :datasets="data_water4"
                                    :labels="watermark_4.data.labels"
                                    :options="watermark_4.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="show === true && port >= 4"
                                  inset
                                ></v-divider>
                                <template v-if="show === true && port >= 5">
                                  <CChartLine
                                    :datasets="data_water5"
                                    :labels="watermark_5.data.labels"
                                    :options="watermark_5.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="show === true && port >= 5"
                                  inset
                                ></v-divider>
                                <template
                                  v-if="
                                    show === true &&
                                      this.prof_pycno == '4'
                                  "
                                >
                                  <CChartLine
                                    :datasets="data_water3"
                                    :labels="watermark_3.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="
                                    show === true 
                                  "
                                  inset
                                ></v-divider>
                              </v-card>
                            </div>
                          </v-row>
                        </v-tab-item>

                        <v-tab-item >
                          <v-row
                            style="margin-top: 40px;"
                          >
                            <div class="md-layout-item">
                              <v-card elevation="4" outlined>
                                <v-row>
                                  <v-col cols="8">
                                    <!--      <v-card-title>
                                   Electrical Conductivity
                                    </v-card-title> -->
                                  </v-col>
                                </v-row>

                                <template v-if="show_EC === false">
                                  <CChartLine 
                                    :datasets="EC_all"
                                    :labels=  "EC3.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="show_EC === false"
                                  inset
                                ></v-divider>
                                <label class="labels_chart" v-if="show_EC === true">Port 1</label>
                                <template
                                  v-if="
                                    show_EC === true 
                                  "
                                >
                                  <CChartLine
                                    :datasets="EC1_data"
                                    :labels="EC1.data.labels"
                                    :options="watermark_1.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_EC === true 
                                  "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_EC === true && port >= 2 ">Port 2</label>
                                <template
                                  v-if="
                                    show_EC === true && port >= 2
                                  "
                                >
                                  <CChartLine
                                    :datasets="EC2_data"
                                    :labels="EC2.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_EC === true && port >= 2
                                  "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_EC === true && port >= 3">Port 3</label>
                                <template
                                  v-if="
                                    show_EC === true && port >= 3
                                  "
                                >
                                  <CChartLine
                                    :datasets="EC3_data"
                                    :labels="EC3.data.labels"
                                    :options="watermark_3.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_EC === true && port >= 3
                                  "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_EC === true && port >= 4">Port 4</label>
                                <template
                                  v-if="
                                    show_EC === true && port >= 4
                                  "
                                >
                                  <CChartLine
                                    :datasets="EC4_data"
                                    :labels="EC4.data.labels"
                                    :options="watermark_4.options"
                                  >
                                  </CChartLine>
                                </template>
                                

                                <v-divider
                                  v-if="
                                    show_EC === true && port >= 4
                                  "
                                  inset
                                ></v-divider>
                              </v-card>
                            </div>
                          </v-row>
                        </v-tab-item>

                        <v-tab-item>


                          <v-row
                            style="margin-top: 40px;"
                          >
                            <div class="md-layout-item">
                              <v-card elevation="4" outlined>
                                <v-row>
                                  <v-col cols="8">
                                    <!--           <v-card-title>
                                      Soil Temperature (°C)
                                    </v-card-title> -->
                                  </v-col>

                                  <v-col
                                    cols="4"
                                  >
                                    <v-btn
                                      @click="show_SL = !show_SL"
                                      color="#4CAF50"
                                      elevation="4"
                                      outlined
                                      small
                                    >
                                      Details
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-down"
                                        v-if="show_SL === false"
                                      ></i>
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-up"
                                        v-if="show_SL === true"
                                      ></i>
                                    </v-btn>
                                  </v-col>
                                </v-row>

                                <template v-if="show_SL === false">
                                  <CChartLine
                                    :datasets="soil_T_all"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="show_SL === false"
                                  inset
                                ></v-divider>
                                <label class="labels_chart" v-if="show_SL === true ">Port 1</label>
                                <template
                                  v-if="
                                    show_SL === true 
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_1"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_SL === true
                                  "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && port >= 2">Port 2</label>
                                <template
                                  v-if="
                                    show_SL === true && port >= 2" 
                                >
                                  <CChartLine
                                    :datasets="soil_T_2"
                                    :labels="soil_temperature2.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider inset></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && port >= 3">Port 3</label>
                                <template
                                  v-if="
                                    show_SL === true && port >= 3
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_3"
                                    :labels="soil_temperature3.data.labels"
                                    :options="watermark_3.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider inset></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && port >= 4">Port 4</label>
                                <template
                                  v-if="
                                    show_SL === true && port >= 4
                                  "
                                >
                                  <CChartLine 
                                    :datasets="soil_T_4"
                                    :labels="soil_temperature4.data.labels"
                                    :options="watermark_4.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider inset></v-divider>
                              </v-card>
                            </div>
                          </v-row>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>

                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
                    >
                      <!-- <v-row>
                        <v-col>
                          <v-btn dark @click="change = true" color="#4CAF50">
                            <i style="color: white" class="fas fa-download"></i>
                            export
                          </v-btn>
                          <vs-dialog
                            overflow-hidden
                            v-model="change"
                            width="600px"
                          >
                            <div>
                              <div class="modal-header">
                                <v-card-title>Export Data</v-card-title>
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span></span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <v-card-text
                                  >To Export Data please choose a Start and End
                                  Date</v-card-text
                                >
                                <div
                                  class="md-layout-item md-small-size-100 md-size-90"
                                >
                                  <v-row>
                                    <v-col>
                                      Start:
                                      <v-row>
                                        <v-col>
                                          <vs-input
                                            v-model="start"
                                            type="date"
                                          />
                                        </v-col>
                                        <v-col>
                                          <vs-input
                                            type="time"
                                            v-model="starttime"
                                            max="nowDate"
                                          />
                                        </v-col> </v-row
                                      >End:
                                      <v-row>
                                        <v-col>
                                          <vs-input v-model="end" type="date" />
                                        </v-col>
                                        <v-col>
                                          <vs-input
                                            type="time"
                                            v-model="endtime"
                                          />
                                        </v-col>
                                      </v-row>

                                      <v-row>
                                        <v-col>
                                          <v-checkbox
                                            v-model="checkbox_one_houre"
                                            :label="'Hourly Data'"
                                            @change="change_($event)"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col>

                                        <v-col>
                                          <v-checkbox
                                            v-model="checkbox_one_12h"
                                            :label="'Bi-daily data'"
                                            @change="change_1($event)"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col>

                                        <v-col
                                          style="height:20px; display: flex; justify-content: flex-end"
                                        >
                                          <v-checkbox
                                            v-model="checkbox_one_day"
                                            @change="change_2($event)"
                                            :label="'Daily Data'"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </div>
                              </div>
                              <div>
                                <v-row
                                  style="justify-content: flex-end; margin-right: 40px;"
                                >
                                  <v-btn
                                    color="blue darken-1"
                                    class="ma-2"
                                    :loading="loading1"
                                    :disabled="loading1"
                                    text
                                    @click="ft_export"
                                  >
                                    export
                                    <template v-slot:loader>
                                      <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                      </span>
                                    </template>
                                  </v-btn>
                                </v-row>
                                <v-row></v-row>
                              </div>
                            </div>
                          </vs-dialog>
                        </v-col>
                      </v-row> -->
                    </div>
                  </div>
                </div>
              </v-tab-item>

              <!-- <v-tab-item>
                <div style="margin-top: 40px;">
                  <v-card
                    style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
                    shaped
                  >
                    <v-row style="margin-top: 50px;">
                      <div class="container col-md-4 col-xl-5">
                        <NewWeather
                          style="border-radius: 25% 10%;"
                          :weath="weath"
                          :time="time"
                          :place="place"
                        />
                      </div>

                      <v-tabs
                        vertical
                        grow
                        color="basil"
                        class="col-md-7 col-xl-7"
                      >
                        <v-tab>Temperature</v-tab>
                        <v-tab>Humidity</v-tab>
                        <v-tab>Cloud Cover</v-tab>
                        <v-tab>Pressure</v-tab>
                        <v-tab>Precipitation</v-tab>
                        <v-tab>Wind Speed</v-tab>
                        <v-tab-item>
                          <TemperatureChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <TestChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <CloudChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <PressureChart :lab="this.weath" />
                        </v-tab-item>

                        <v-tab-item>
                          <PrecipitationChart :lab="this.weath" />
                        </v-tab-item>

                        <v-tab-item>
                          <WindSpeedChart :lab="this.weath" />
                        </v-tab-item>
                      </v-tabs>
                    </v-row>
                  </v-card>
                </div>
              </v-tab-item> -->

              <v-tab-item>
                <div
                  style="margin-top: 50px; margin-left: 20px; margin-right: 20px; border-color: black;"
                >
                  <v-card
                    style="padding-top: 20px; padding-left: 20px; padding-right: 20px;"
                    shaped
                  >
                    <form>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="fname"
                            :error-messages="nameErrors"
                            label="Nom de l'agriculteur"
                            required
                            @input="$v.fname.$touch()"
                            @blur="$v.fname.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="nodeId"
                            :error-messages="ndeIdErrors"
                            label="Capteur ID"
                            required
                            @input="$v.nodeId.$touch()"
                            @blur="$v.nodeId.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="lat"
                            :error-messages="latErrors"
                            label="latitude"
                            required
                            @input="$v.lat.$touch()"
                            @blur="$v.lat.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="long"
                            :error-messages="longErrors"
                            label="longitude"
                            required
                            @input="$v.long.$touch()"
                            @blur="$v.long.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="st"
                            :error-messages="surfaceErrors"
                            label="Total area"
                            required
                            @input="$v.st.$touch()"
                            @blur="$v.st.$touch()"
                            suffix="ha"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-select
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="items[is]"
                            :items="items"
                            @change="changeRoute_irrig"
                            :error-messages="irrigationSystem"
                            label="Irrigation system"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="prof_pycno"
                            :error-messages="Errors"
                            label="depth Sensor"
                            required
                            @input="$v.prof_pycno.$touch()"
                            @blur="$v.prof_pycno.$touch()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-select
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="items_culture[cult]"
                            :items="items_culture"
                            @change="changeRoute_culture"
                            :error-messages="irrigationSystem"
                            label="Culture"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>Crop Density :</v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cd1"
                            :error-messages="cd1Errors"
                            required
                            @input="$v.cd1.$touch()"
                            @blur="$v.cd1.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>X</v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cd2"
                            :error-messages="cd2Errors"
                            required
                            @input="$v.cd2.$touch()"
                            @blur="$v.cd2.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-menu
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="validated ? '' : disabled"
                                id="nour"
                                v-model="date1"
                                label="Planting date"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date1"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="validated ? '' : disabled"
                                id="nour"
                                v-model="dateD"
                                label="Start date"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateD"
                              @input="menu3 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="frod"
                            :error-messages="frodErrors"
                            label="Flow rate of drippers"
                            required
                            @input="$v.frod.$touch()"
                            @blur="$v.frod.$touch()"
                            suffix="l/h"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="sod"
                            :error-messages="sodErrors"
                            label="Spacing of drippers"
                            required
                            @input="$v.sod.$touch()"
                            @blur="$v.sod.$touch()"
                            suffix="m"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="nor"
                            :error-messages="norErrors"
                            label="Number of ramps / line"
                            required
                            @input="$v.nor.$touch()"
                            @blur="$v.nor.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="clay"
                            :error-messages="clayErrors"
                            label="Clay Content"
                            required
                            @input="$v.clay.$touch()"
                            @blur="$v.clay.$touch()"
                            suffix="%"
                          ></v-text-field>
                          <!--            <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cou"
                            :error-messages="couErrors"
                            label="Coefficient of uniformity"
                            required
                            @input="$v.cou.$touch()"
                            @blur="$v.cou.$touch()"
                            suffix="%"
                          ></v-text-field> -->
                        </v-col>
                      </v-row>
                      <!--  <v-row>
                        <v-col>
                         <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="ire"
                            :error-messages="ireErrors"
                            label="Irrigation efficiency"
                            required
                            @input="$v.ire.$touch()"
                            @blur="$v.ire.$touch()"
                            suffix="%"
                          ></v-text-field> 
                          
                        </v-col>
                      </v-row>-->
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Soil"
                            :error-messages="soilErrors"
                            label="Soil texture"
                            required
                            @input="$v.Soil.$touch()"
                            @blur="$v.Soil.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="oms"
                            :error-messages="omsErrors"
                            label="Organic matter"
                            required
                            @input="$v.oms.$touch()"
                            @blur="$v.oms.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!--   <v-row>
                        <v-col>
                <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Ss"
                            :error-messages="ssErrors"
                            label="  Soil salinity"
                            required
                            @input="$v.Ss.$touch()"
                            @blur="$v.Ss.$touch()"
                          ></v-text-field>  
                        </v-col>
                        <v-col>
                      
                        </v-col>
                      </v-row> -->
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Limon"
                            :error-messages="limonErrors"
                            label="Limon content"
                            required
                            @input="$v.Limon.$touch()"
                            @blur="$v.Limon.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="sand"
                            :error-messages="sandErrors"
                            label="Sand content"
                            required
                            @input="$v.sand.$touch()"
                            @blur="$v.sand.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="min"
                            :error-messages="limonErrors"
                            label="Minimant Soil moisture"
                            required
                            @input="$v.Limon.$touch()"
                            @blur="$v.Limon.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="max"
                            :error-messages="sandErrors"
                            label="Maximant Soil moisture"
                            required
                            @input="$v.sand.$touch()"
                            @blur="$v.sand.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-btn color="#4CAF50" @click="Myfunction"
                            >Edit</v-btn
                          >
                        </v-col>
                        <v-col>
                          <span v-if="errdata" style="color: #4CAF50;">{{
                            errdata
                          }}</span>
                          <span v-if="err" style="color: red;">{{ err }}</span>
                        </v-col>
                        <v-col>
                          <v-btn color="#4CAF50" @click="editnode">Save</v-btn>
                        </v-col>
                      </v-row>
                    </form>
                  </v-card>
                </div>
              </v-tab-item>
            </v-tabs>
          </CCardBody>
        </CCard>
      </CCol>
    </div>
  </div>
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";
import moment from "moment";
import FileSaver from "file-saver";
import axios from "axios";
/* import Stepper from "../components/Cards/Stepper"; */
import GetNodes from "@/services/NodeData";
import router from "@/routes";
import DateFo from "../services/DateFormat";
import { mdiWaterPercent, mdiEye, mdiWeatherWindy } from "@mdi/js";
/* import Weather from "@/components/Cards/Weather";
import Temperature from "@/components/Cards/Temperature"; */
import isEmpty from "@/outils/isEmpty";
/* import Measurements from "@/components/Cards/Measurements"; */
import WeatherForecast from "../services/WeatherForecast";
/* import WeatherApp from "@/components/Cards/WeatherApp";
import tempchart from "@/components/Cards/TempChart";
import Chart from "@/components/Charts/LineMarker"; */
import NewWeather from "@/components/Cards/NewWeather";

import TestChart from "@/components/Charts/CChartLineExample";

import CloudChart from "@/components/WeatherCharts/Cloud";
import PressureChart from "@/components/WeatherCharts/Pressure";
import PrecipitationChart from "@/components/WeatherCharts/Precipitation";

import WindSpeedChart from "@/components/WeatherCharts/windSpeed";
import TemperatureChart from "@/components/WeatherCharts/Temperature ";
import TopNavbarVue from "./Layout/TopNavbar.vue";

export default {
  components: {
    CChartLine,
    TestChart,
    CloudChart,
    PrecipitationChart,
    PressureChart,
    WindSpeedChart,
    TemperatureChart,
    NewWeather,
  },
  data() {
    return {
      dates: [
        new Date().toISOString().slice(0, 10),
        new Date().toISOString().slice(0, 10),
      ],
      port:0,
      value_scal: "Min/Max",
      value: "day",
      nowDate: new Date().toISOString().slice(0, 10),
      modalTest: false,
      starttime: null,
      endtime: null,
      checkbox_one_houre: false,
      checkbox_one_12h: false,
      checkbox_one_day: false,
      change: false,
      colorx: "#8B0000",
      tabs: ["Calculator", "Shopping cart", "Charts"],
      activeTab: 1,
      validated: 1,
      err: null,
      errdata: "",
      select: null,
      items_culture: [
        "Oliviers",
        "Carottes",
        "Onionsc (secs)",
        "Onionsc (verts)",
        "Melons",
        "Pasteques",
        "Bettrave",
        "Mais (grains)",
        "Mais",
        "Agrumes",
        "Caroubier",
        "Pêcher",
        "Nectarine",
        "Prunier",
        "Grenadier",
        "Cognassier",
        "Kaki",
        "Vigne",
      ],
      items: ["Drip irrigation", "Sprinkler irrigation", "Surface irrigation"],
      clay: "",
      Limon: "",
      sand: "",
      min: "",
      max: "",
      fname: "",
      nodeId: "",
      lat: "",
      cult: "",
      prof_pycno: "",
      long: "",
      st: "",
      ws: "",
      is: null,
      // isn: "",
      cd1: "",
      cd2: "",
      rootd: "",
      frod: "",
      sod: "",
      nor: "",
      cou: "",
      ire: "",
      Ss: "",
      oms: "",
      Soil: "",
      Date_toshow: "",
      temp_time: "",
      e1: 1,
      date1: new Date().toISOString().substr(0, 10),
      dateD: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      menu3: false,
      place: "",
      details: [],
      loader: null,
      loading1: false,
      end: null,
      start: null,
      dialog: false,
      date_req: null,
      date: new Date(),
      forecast: new WeatherForecast(),
      show: true,
      show_EC: true,
      show_SL: true,
      loading: true,
      icons: {
        mdiWaterPercent,
        mdiEye,
        mdiWeatherWindy,
      },
      weath: [],
      time: "",
      result: [],
      EC1: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC2: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC3: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC4: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      watermark_1: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,

          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index) {
                    return index % 3 === 0 ? value : "";
                  },
                  align: "center",
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                },
                ticks: {
                  callback: function(value) {
                    return value + "%";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_2: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_3: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_4: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_5: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      soil_temperature1: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      soil_temperature2: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      soil_temperature3: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      soil_temperature4: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      soil_temperature: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      air_humidity: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      Temp_air: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      Sunlight: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      Sunlight1: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      Sunlight2: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 1000,
          high: 30000,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      rssi: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      lqi: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 0,
          high: 100,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      battery: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 0,
          high: 100,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      wt1: [],
      timing: [],
    };
  },
  computed: {
    EC_all() {
        return [
          {
            label: "Port 1",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.EC1.data.series[0],
          },
          {
            label: "Port 2",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
          {
            label: "Port 3",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
          {
            label:  "Port 4",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.EC4.data.series[0],
          },
        ];
    },
    EC1_data() {
      return [
        {
          label: "at 15cm / (mS/cm)",
          backgroundColor: "rgba(13, 101, 70,0.6)",
          data: this.EC1.data.series[0],
        },
      ];
    },
    EC2_data() {
      return [
        {
          label: "at 15cm / (mS/cm)",
          backgroundColor: "rgba(228, 255, 26,0.6)",
          data: this.EC2.data.series[0],
        },
      ];
    },
    EC3_data() {
      return [
        {
          label: "at 15cm / (mS/cm)",
          backgroundColor: "rgb(14, 173, 83)",
          data: this.EC3.data.series[0],
        },
      ];
    },
    EC4_data() {
      return [
        {
          label: "at 15cm / (mS/cm)",
          backgroundColor: "rgba(13, 101, 70,0.6)",
          data: this.EC4.data.series[0],
        },
      ];
    },
    soil_T_all() {
      if (this.nodeId === 'z6-19027' || this.nodeId === 'z6-19028' || this.nodeId === 'z6-19029' || this.nodeId === 'z6-19030' || this.nodeId == "z6-19032" )
        return [
          {
            label: this.nodeId === 'z6-19027' ? "0 WS50%" :(this.nodeId === 'z6-19028' ? "P30 WS50%" :(this.nodeId === 'z6-19029' ? "0 WS50%" : (this.nodeId === 'z6-19030' ? "P30 WS50%" : "Port 1" ))),
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
          {
            label: this.nodeId === 'z6-19027' ? "0 WS25%" :(this.nodeId === 'z6-19028' ? "P30 WS25%" :(this.nodeId === 'z6-19029' ? "0 WS25%" : (this.nodeId === 'z6-19030' ? "P30 WS25%" : "Port 2"))),
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
          {
            label: this.nodeId === 'z6-19027' ? "0 FI100%" :(this.nodeId === 'z6-19028' ? "F30 FI100%" :(this.nodeId === 'z6-19029' ? "0 FI100%" : (this.nodeId === 'z6-19030' ? "F30 FI100%" : "Port 3"))),
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
          {
            label: this.nodeId === 'z6-19027' ? "F30 WS50%" :(this.nodeId === 'z6-19028' ? "P30 FI100%" :(this.nodeId === 'z6-19029' ? "F30 WS50%" : (this.nodeId === 'z6-19030' ? "P30 FI100%" : "Port 4"))),
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.soil_temperature4.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-05840")
        return [
        {
            label: "at 30cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
          {
            label: "at 15cm / (°C)",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
          {
            label: "at 15cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-05840-2")
        return [
          {
            label: "at 15cm / (°C)",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ];
      else
        return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature.data.series[0],
          },
          this.prof_pycno == "4"
            ? {
                label: "at 15cm / (°C)",
                backgroundColor: "rgba(255, 181, 7,0.6)",
                data: this.soil_temperature2.data.series[0],
              }
            : {},
        ];
    },
    soil_T_1() {
      if (this.nodeId === 'z6-19027' || this.nodeId === 'z6-19028' || this.nodeId === 'z6-19029' || this.nodeId === 'z6-19030' || this.nodeId == "z6-19032" )
        return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ]
      else if (this.nodeId == "z6-05840")
      return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ]
     else return [
        {
          label: "at 15cm / (°C) ",
          backgroundColor: "rgba(250, 131, 4,0.7)",
          data: this.soil_temperature1.data.series[0],
        },
      ];
    },
    soil_T_2() {
      if (this.nodeId === 'z6-19027' || this.nodeId === 'z6-19028' || this.nodeId === 'z6-19029' || this.nodeId === 'z6-19030'|| this.nodeId === "z6-05840" || this.nodeId == "z6-19032")
        return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
        ]
     else  return [
        {
          label: "at 15cm / (°C) ",
          backgroundColor: "rgba(255, 181, 7,0.6)",
          data: this.soil_temperature2.data.series[0],
        },
      ];
    },
    soil_T_3() {
      if (this.nodeId === 'z6-19027' || this.nodeId === 'z6-19028' || this.nodeId === 'z6-19029' || this.nodeId === 'z6-19030' || this.nodeId === "z6-05840" || this.nodeId == "z6-19032")
        return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ]
     else return [
        {
          label: "at 15cm / (°C) ",
          backgroundColor: "rgba(228, 255, 26,0.6)",
          data: this.soil_temperature3.data.series[0],
        },
      ];
    },
    soil_T_4() {
      if (this.nodeId === 'z6-19027' || this.nodeId === 'z6-19028' || this.nodeId === 'z6-19029' || this.nodeId === 'z6-19030' || this.nodeId == "z6-19032" )
        return [
          {
            label: "at 15cm / (°C) ",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.soil_temperature4.data.series[0],
          },
        ]
     else return [
        {
          label: "at 15cm / (°C) ",
          backgroundColor: "rgba(13, 101, 70,0.6)",
          data: this.soil_temperature4.data.series[0],
        },
      ];
    },
    defaultDatasets() {
        return [
          {
            label: "Port 1",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            fill: true,
            data: this.watermark_1.data.series[0],
          },
          {
            label:"Port 2",
            backgroundColor: "rgba(158, 240, 26,0.6)",
            data: this.watermark_2.data.series[0],
          },
          {
            label: "Port 3",
            backgroundColor: "rgba(255, 183, 0,0.6)",
            data: this.watermark_3.data.series[0],
          },
          {
            label: "Port 4",
            backgroundColor: "rgb(127, 200, 248,0.8)",
            data: this.watermark_4.data.series[0],
          },
        ];
     
      
    },
    data_water1() {
        
        return [
          {
            label: "at 15cm / %",
            backgroundColor: "#60d394",
            data: this.watermark_1.data.series[0],
          },
        ];
       
    },
    data_water2() {
        return [
          {
            label: "at 15cm / %",
            backgroundColor: "rgb(220, 47, 2,0.7)",
            data: this.watermark_2.data.series[0],
          },
        ];
      
    },
    data_water3() {
        return [
          {
            label: "at 15cm / %",
            backgroundColor: "rgb(127, 200, 248,0.8)",
            data: this.watermark_3.data.series[0],
          },
        ];
       
    },
    data_water4() {
        return [
          {
            label: "at 15cm / %",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.watermark_4.data.series[0],
          },
        ];
       
    },
    data_water5() {
        return [
          {
            label: "at 15cm / %",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.watermark_5.data.series[0],
          },
        ];
    },
    data_soil_temperature() {
      return [
        {
          label: "Temperature (°C) ",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.soil_temperature.data.series[0],
        },
      ];
    },

    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    year() {
      return this.date.getFullYear();
    },
    period() {
      let hour = this.date.getHours();

      return hour > 5 && hour < 18 ? "app--day" : "app--night";
    },
  },
  methods: {
    change_: function(e) {
      this.checkbox_one_12h = false;
      this.checkbox_one_day = false;
    },
    change_1: function(e) {
      this.checkbox_one_houre = false;
      this.checkbox_one_day = false;
    },
    change_2: function(e) {
      this.checkbox_one_houre = false;
      this.checkbox_one_12h = false;
    },
    edit_min_max() {
      if (this.value_scal == "Min/Max") {
        this.value_scal = "Autoscale";

        this.watermark_1.options.scales.yAxes = [
          {
            display: true,
            ticks: {
              min: Number(this.min),
              max: Number(this.max) + 15 > 100 ? 100 : Number(this.max) + 15,
              callback: function(value, index, values) {
                return value + "%";
              },
            },
          },
        ];

        this.watermark_1.options.scales.xAxes = [
          {
            ticks: {
              callback: function(value, index, values) {
                return index % 3 === 0 ? value : "";
              },
              align: "center",
            },
          },
        ];
      } else {
        this.value_scal = "Min/Max";
        this.watermark_1.options.scales.yAxes = [
          {
            display: true,
          },
        ];
      }

      let temp = this.watermark_1.data;
      this.watermark_1.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_1.data = temp;

      temp = this.watermark_2.data;
      this.watermark_2.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_2.data = temp;

      temp = this.watermark_3.data;
      this.watermark_3.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_3.data = temp;

      temp = this.watermark_4.data;
      this.watermark_4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_4.data = temp;

      temp = this.watermark_5.data;
      this.watermark_5.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_5.data = temp;
    },
    clean_chart() {
      this.EC1.data = {
        labels: [],
        series: [[]],
      };
      this.EC2.data = {
        labels: [],
        series: [[]],
      };
      this.EC3.data = {
        labels: [],
        series: [[]],
      };
      this.EC4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_1.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_2.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_3.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_5.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature2.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature3.data = {
        labels: [],
        series: [[]],
      };
      this.air_humidity.data = {
        labels: [],
        series: [[]],
      };
      this.Temp_air.data = {
        labels: [],
        series: [[]],
      };
      this.Sunlight.data = {
        labels: [],
        series: [[]],
      };
      this.lqi.data = {
        labels: [],
        series: [[]],
      };
      this.rssi.data = {
        labels: [],
        series: [[]],
      };
      this.battery.data = {
        labels: [],
        series: [[]],
      };
    },

    load_data(btn_vl) {
      var days = 2;
      var type = true;
      if (btn_vl == "month") {
        days = 28;
      } 
      else 
      if (btn_vl == "week") {
       days = 7;
      } 
      else if (btn_vl == "day") {
        days = 2;
      }
      else
      {
        type = false;
        days = btn_vl[0];
      }
      let get = this.$router.history.current.query;
      this.clean_chart();
      if (this.dates[1] == undefined) this.dates[1] = this.dates[0];

        GetNodes.sensor_get_dates_fixed(get.id,days,type).then(
        (data) => {
          this.port = data.length;
          setTimeout(() => {
            for (let j = 0; j < data.length; j++) {
              if (data[j] !== undefined) {
                for(let i = 0; i < data[j].values.length; i++)
                {
                    if (j == 0)
                    {
                      console.log("######################");
                      console.log(data[j].values[i].Datetime);
                      this.watermark_1.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      console.log(this.watermark_1.data.labels);
                      this.EC1.data.labels.push(
                          DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.soil_temperature1.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      
                    }
                    if (j == 1)
                    {
                      this.watermark_2.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.EC2.data.labels.push(
                          DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.soil_temperature2.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                    }
                    if (j == 2)
                    {
                      this.watermark_3.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.EC3.data.labels.push(
                          DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.soil_temperature3.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                    }
                    if (j == 3)
                    {
                      this.watermark_4.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.EC4.data.labels.push(
                          DateFo.date_chart(data[j].values[i].Datetime)
                      );
                      this.soil_temperature4.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                    }
                    if (j == 4)
                    {
                      this.watermark_5.data.labels.push(
                        DateFo.date_chart(data[j].values[i].Datetime)
                      );
                    }

                    if (j == 5)
                    {
                      // this.watermark_6.data.labels.push(
                      //   DateFo.date_chart(data[j].values[i].Datetime)
                      // );
                    }
                } 
              }
            }

            for (let j = 0; j < data.length; j++) {
              if (data[j] !== undefined) {
                for(let i = 0; i < data[j].values.length; i++)
                {
                  if (j == 0)
                  {
                      this.watermark_1.data.series[0].push(data[j].values[i].water_Content);
                      this.soil_temperature1.data.series[0].push(data[j].values[i].soil_Temperature);
                      this.EC1.data.series[0].push(data[j].values[i].bulk_EC);
                  }
                  if (j == 1)
                  {
                    this.watermark_2.data.series[0].push(data[j].values[i].water_Content);
                    this.soil_temperature2.data.series[0].push(data[j].values[i].soil_Temperature);
                    this.EC2.data.series[0].push(data[j].values[i].bulk_EC);
                  }
                  if (j == 2)
                  {
                    this.watermark_3.data.series[0].push(data[j].values[i].water_Content);
                    this.soil_temperature3.data.series[0].push(data[j].values[i].soil_Temperature);
                    this.EC3.data.series[0].push(data[j].values[i].bulk_EC);
                  }
                  if (j == 3)
                  {
                    this.watermark_4.data.series[0].push(data[j].values[i].water_Content);
                    this.soil_temperature4.data.series[0].push(data[j].values[i].soil_Temperature);
                    this.EC4.data.series[0].push(data[j].values[i].bulk_EC);
                  }
                  if (j == 4)
                  {
                    this.watermark_5.data.series[0].push(data[j].values[i].water_Content);
                  }
                }
              }
            }

          }, 500);
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      );
      
    },
    changeRoute_culture(selectObj) {
      this.items_culture.forEach((el, index) => {
        if (el === selectObj) {
          this.cult = index;
          // alert("changeRoute_culture");
        }
      });
    },
    changeRoute_irrig(selectObj) {
      this.items.forEach((el, index) => {
        if (el === selectObj) {
          this.is = index;
          // alert("changeRoute_irrig");
        }
      });
    },
    update(data, options, override) {
      if (data) {
        this.data = data || {};
        this.data.labels = this.data.labels || [];
        this.data.series = this.data.series || [];
        // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
        this.eventEmitter.emit("data", {
          type: "update",
          data: this.data,
        });
      }

      if (options) {
        this.options = Chartist.extend(
          {},
          override ? this.options : this.defaultOptions,
          options
        );

        // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
        // Otherwise we re-create the optionsProvider at this point
        if (!this.initializeTimeoutId) {
          this.optionsProvider.removeMediaQueryListeners();
          this.optionsProvider = Chartist.optionsProvider(
            this.options,
            this.responsiveOptions,
            this.eventEmitter
          );
        }
      }

      // Only re-created the chart if it has been initialized yet
      if (!this.initializeTimeoutId) {
        this.createChart(this.optionsProvider.getCurrentOptions());
      }

      // Return a reference to the chart object to chain up calls
      return this;
    },
    openLoading() {
      if (this.loading === true) {
        const loading = this.$vs.loading({
          target: this.$refs.content,
          color: "dark",
          type: "circles",
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
      }
    },
    Myfunction() {
      this.validated = !this.validated;
    },
    editnode() {
      let get = this.$router.history.current.query;
      let d = {
        Clay: this.clay,
        Limon: this.Limon,
        Sand: this.sand,
        min: this.min,
        max: this.max,
        FarmerName: this.fname,
        NodeId: this.nodeId,
        latitude: this.lat,
        Culture: this.cult,
        pycno_prof: this.prof_pycno,
        longitude: this.long,
        Totalarea: this.st,
        IrrigationSystem: this.is,
        CropDensit1: this.cd1,
        CropDensit2: this.cd2,
        depthroot: this.rootd,
        DripppersFlowrate: this.frod,
        DrippersSpaces: this.sod,
        Numberramps: this.nor,
        Cofficientuinf: this.cou,
        Irrigationefficiency: this.ire,
        Soilsalinity: this.Ss,
        OrganicMatter: this.oms,
        Soiltextue: this.Soil,
        Date: this.date1.substr(0, 10),
      };

      GetNodes.editnode(get.id, d)
        .then(() => (this.errdata = "Updated"))
        .catch(() => (this.err = "Check the fields and try again"));
    },
    clear() {
      (this.clay = ""),
        (this.Limon = ""),
        (this.sand = ""),
        (this.fname = ""),
        (this.nodeId = ""),
        (this.lat = ""),
        (this.cult = ""),
        (this.prof_pycno = ""),
        (this.long = ""),
        (this.st = ""),
        (this.is = ""),
        (this.cd1 = ""),
        (this.cd2 = ""),
        (this.rootd = ""),
        (this.frod = ""),
        (this.sod = ""),
        (this.nor = ""),
        (this.cou = ""),
        (this.ire = ""),
        (this.Ss = ""),
        (this.oms = ""),
        (this.Soil = "");
      this.min = "";
      this.max = "";
    },
    submit() {
      this.$v.nodeId.$touch();
      this.$v.fname.$touch();
      this.$v.lat.$touch();
      this.$v.long.$touch();
      this.$v.st.$touch();
      // this.$v.ws.$touch();
      this.$v.is.$touch();
      // this.$v.isn.$touch();

      console.log("dkhlaaaat");
      console.log(this.e1);
      if (
        !this.$v.nodeId.$error &&
        !this.$v.lat.$error &&
        !this.$v.long.$error &&
        !this.$v.st.$error &&
        !this.$v.is.$error &&
        !this.$v.fname.$error
      ) {
        console.log("dkhlaaat bla error");
        console.log(this.e1);
        this.e1 = 2;
        console.log(this.e1);
      }
    },
    submitII() {
      this.$v.ire.$touch();
      this.$v.cou.$touch();
      this.$v.nor.$touch();
      this.$v.sod.$touch();
      this.$v.frod.$touch();
      this.$v.rootd.$touch();
      this.$v.cd2.$touch();
      this.$v.cd1.$touch();
      this.$v.cult.$touch();
      this.$v.prof_pycno.$touch();

      if (
        !this.$v.ire.$error &&
        !this.$v.cou.$error &&
        !this.$v.nor.$error &&
        !this.$v.rootd.$error &&
        !this.$v.frod.$error &&
        !this.$v.sod.$error &&
        !this.$v.cd2.$error &&
        !this.$v.cd1.$error &&
        !this.$v.cult.$error &&
        !this.$v.prof_pycno.$error
      ) {
        this.e1 = 3;
        console.log(this.e1);
      }
    },
    getinfos() {
      router.push("/infos?id=" + this.$router.history.current.query.id);
    },
    ft_export() {
      this.loader = "loading1";
      let get = this.$router.history.current.query;
      if (
        !isEmpty(this.start) &&
        !isEmpty(this.end) &&
        !isEmpty(this.starttime) &&
        !isEmpty(this.endtime)
      ) {
        this.starttime = "T" + this.starttime;
        this.endtime = "T" + this.endtime;

        this.starttime += ":00.000Z";
        this.endtime += ":00.000Z";

        this.start += this.starttime;
        this.end += this.endtime;

        let value_check =
          this.checkbox_one_houre == true
            ? 1
            : this.checkbox_one_12h == true
            ? 2
            : 3;

        //1 -- >  Every hour
        //2 -- >  Every 12h
        //3 -- >  Every Day
        GetNodes.check_data(get.id, this.start, this.end, value_check)
          .then(
            (result) => {
              if(result.data)
              {
                  GetNodes.export_data(get.id, this.start, this.end, value_check)
                  .then(
                    () => {
                      setTimeout(function() {
                        window.open("https://agriad.ga/exportData/Node-"+get.id+".xlsx",'_blank');
                      }, 9900);
                    }
                    // GetNodes.download(get.id)
                  )
                  .catch((err) => console.log(err));
              }
              else
              {
                alert("Don't find data for this Date :"+this.start+"  ,  "+this.end);
              }
            }
            // GetNodes.download(get.id)
          )
          .catch((err) => console.log(err));
        
      } else alert("check the fields");
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 5000);
      this.loader = null;
    },
  },
  beforeCreate() {
    let get = this.$router.history.current.query;
    GetNodes.getNodeDetails(get.id)
      .then((res) => {
        if (isEmpty(res)) router.push("/tables");

        (this.clay = res.Clay),
          (this.Limon = res.Limon),
          (this.sand = res.Sand),
          (this.min = res.min),
          (this.max = res.max),
          (this.fname = res.FarmerName),
          (this.nodeId = res.NodeId),
          (this.lat = res.latitude),
          (this.cult = res.Culture),
          (this.prof_pycno = res.pycno_prof),
          (this.long = res.longitude),
          (this.st = res.Totalarea),
          (this.is = res.IrrigationSystem),
          (this.cd1 = res.CropDensit1),
          (this.cd2 = res.CropDensit2),
          (this.rootd = res.depthroot),
          (this.frod = res.DripppersFlowrate),
          (this.sod = res.DrippersSpaces),
          (this.nor = res.Numberramps),
          (this.cou = res.Cofficientuinf),
          (this.ire = res.Irrigationefficiency),
          (this.Ss = res.Soilsalinity),
          (this.oms = res.OrganicMatter),
          (this.Soil = res.Soiltextue),
          (this.e1 = 1);

        if (res.Date) this.date1 = res.Date.substr(0, 10);

        if (res.DateD) this.dateD = res.DateD.substr(0, 10);

        this.details = res;

        if (this.details.Date)
          this.details.Date = this.details.Date.substr(0, 10);

        return GetNodes.getWeatherData(res.latitude, res.longitude);
      })
      .then((data) => {
        this.weath = data;
        this.$store.state.weath = data;
        console.log(this.weath);

        this.time = DateFo.fullDate(this.weath.currently.time);
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.weath.latitude},${this.weath.longitude}&key=AIzaSyChmM8jDn3mIpFEK5caePyw3IAci5-mU1o&region=MA`
          )
          .then((data) => {
            this.place = data.data.plus_code.compound_code;

            if (data.data.plus_code.compound_code == undefined)
              this.place = "dakhla";
            else this.place = data.data.plus_code.compound_code;
          });
        // return GetNodes.getnodedata(get.id);
      });
  },
  created() {
    this.load_data("day");
  },
  mounted() {
    this.openLoading();
  },
};
</script>

<style scoped>
.content-div {
  width: 200px;
  height: 200px;
  box-shadow: 0px 6px 25px -10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 0.6rem;
}

.tba {
  font-size: 50px;
  color: black;
}
/** App **/
label {
  display: block;
  font: 1rem "Fira Sans", sans-serif;
}

input,
label {
  margin: 0.4rem 0;
}
.app {
  height: 100vh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.app--day a:hover {
  color: rgba(46, 146, 167, 0.9);
}

.app--night a:hover {
  color: rgba(0, 0, 0, 0.5);
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.chart-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 84px);
}
.labels_chart {
  text-align: center;
  color: #118d3e;
  font-family: Roboto, Helvetica, Arial;
  font-size: x-large;
  border: 2px solid #a9b6c4 !important;
}
</style>
